import { motion } from "framer-motion";
import { Droplets, Flame, Phone } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function CurrentRate() {
  const { t } = useI18n();
  return (
    <section className="py-14 md:py-20 bg-dd-page" data-testid="current-rate-section">
      <div className="dd-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-4xl"
        >
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-3 text-dd-gold">
              <span className="h-px w-10 bg-dd-gold/60" />
              <span className="dd-label tracking-[0.3em] text-[0.72rem]">{t.rate.label}</span>
              <span className="h-px w-10 bg-dd-gold/60" />
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-5 md:gap-7">
            {/* Milk card */}
            <div className="bg-white border border-dd-gold/25 rounded-2xl p-8 md:p-10 shadow-[0_20px_60px_-30px_rgba(15,46,32,0.3)] hover:border-dd-gold/60 transition-colors" data-testid="rate-milk-card">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-dd-gold-soft to-dd-gold-light/40 mx-auto">
                <Droplets className="w-6 h-6 text-[#8F6E28]" strokeWidth={1.5} />
              </div>
              <div className="dd-label text-dd-ink-muted tracking-[0.28em] text-[0.68rem] text-center mt-5">{t.rate.milk}</div>
              <div className="font-serif text-5xl md:text-6xl text-dd-ink mt-2 text-center tracking-tight">
                ₹100<span className="text-base md:text-lg text-dd-ink-muted font-sans">/litre</span>
              </div>
              <div className="mt-3 text-center">
                <span className="inline-block text-[0.72rem] font-semibold uppercase tracking-[0.2em] text-[#8F6E28] border-b border-dd-gold/40 pb-0.5">{t.rate.milk_sub}</span>
              </div>
            </div>

            {/* Ghee card */}
            <div className="bg-white border border-dd-gold/25 rounded-2xl p-8 md:p-10 shadow-[0_20px_60px_-30px_rgba(15,46,32,0.3)] hover:border-dd-gold/60 transition-colors flex flex-col" data-testid="rate-ghee-card">
              <div className="flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-dd-gold-soft to-dd-gold-light/40 mx-auto">
                <Flame className="w-6 h-6 text-[#8F6E28]" strokeWidth={1.5} />
              </div>
              <div className="dd-label text-dd-ink-muted tracking-[0.28em] text-[0.68rem] text-center mt-5">{t.rate.ghee}</div>
              <div className="font-serif text-2xl md:text-3xl text-dd-ink mt-3 leading-tight text-center flex-1">
                {t.rate.ghee_price}
              </div>
              <a
                href="tel:+919819933676"
                className="mt-5 inline-flex items-center justify-center gap-2 bg-gradient-to-b from-dd-gold to-[#8F6E28] hover:from-dd-gold-light hover:to-dd-gold text-dd-ink-dark px-6 py-3 rounded-full text-sm font-bold tracking-wide shadow-lg shadow-[rgba(201,162,76,0.25)] transition-all self-center"
                data-testid="ghee-call-btn"
              >
                <Phone className="w-4 h-4" strokeWidth={2.25} /> Call Now
              </a>
            </div>
          </div>

          <p className="text-center text-sm text-dd-cream-muted mt-8 italic font-serif">{t.rate.note}</p>
        </motion.div>
      </div>
    </section>
  );
}
